import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AsyncRequestService } from 'src/app/core/async-request/async-request.service';
import { API_URL_COMPANIES, API_URL_PREFIX } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';

@Injectable({
  providedIn: 'root',
})
export class MassActionsService {
  selectTaskBS = new EventEmitter();
  private _idsSelection: number[] = [];

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private asyncRequestService: AsyncRequestService,
    private errorHandlingService: ErrorHandlingService,
    private http: HttpClient
  ) {}

  get idsSelection() {
    return this._idsSelection;
  }

  /**
   * Select or unselect a task.
   *
   * @param checked
   * @param id
   */
  toggleOneTask(checked: boolean, id: number) {
    if (checked) {
      this._idsSelection.push(id);
    } else {
      const index = this._idsSelection.indexOf(id);
      if (index > -1) {
        this._idsSelection.splice(index, 1);
      }
    }

    this.selectTaskBS.emit();
  }

  /**
   * Select or unselect a list of tasks.
   *
   * @remarks
   * Don't put ids = [] as default and remove checked, because we can receive ids and wants to unselect
   *
   * @param checked true for select, false for unselect
   * @param ids list of ids to select, optional if checked is false
   */
  toggleTasks(checked: boolean, ids?: number[]) {
    if (checked) {
      this._idsSelection = ids;
    } else {
      this._idsSelection = [];
    }
  }

  archive(taskIds: number[]): Observable<any> {
    return this.http
      .post<any>(`${API_URL_PREFIX}/${this.alcmeonContextService.companyId}/tasks/archive`, {
        tasks_ids: taskIds,
      })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  exportTasks(taskIds: number[]): Observable<{ id: number }> {
    return this.http
      .post<{ id: number }>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/tasks/exports`, {
        tasks_ids: taskIds,
      })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  exportConversations(taskIds: number[]): Observable<{ url: string }> {
    return this.asyncRequestService
      .post<{ url: string }>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/tasks/conversations-exports`,
        {
          tasks_ids: taskIds,
        }
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
